class ScxAccordion extends HTMLElement {
  constructor() {
    super();

    try {
      this.buttonElem = document.querySelector(this.getAttribute("data-open-elem"));
      this.content = document.querySelector(this.getAttribute("data-content-elem"));
      this.openIcon = document.querySelector(this.getAttribute("data-open-icon"));
      this.closeIcon = document.querySelector(this.getAttribute("data-close-icon"));
    } catch (e) {
      console.error("Missing attributes.");
    }
  }

  connectedCallback() {
    this.buttonElem.addEventListener("click", () => {
      const currentState = this.content.getAttribute("data-open");

      this.content.setAttribute("data-open", currentState === "true" ? "false" : "true");
      this.openIcon.setAttribute("data-show", currentState === "true" ? "true" : "false");
      this.closeIcon.setAttribute("data-show", currentState === "true" ? "false" : "true");
    });
  }
}

customElements.define("scx-accordion", ScxAccordion);
